"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GridColumnsController", {
    enumerable: true,
    get: function() {
        return GridColumnsController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _gridcolumnsservice = require("~/services/grid-columns.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let GridColumnsController = class GridColumnsController {
    async columnList(context, gridViewId) {
        return await this.gridColumnsService.columnList(context, {
            gridViewId
        });
    }
    async gridColumnUpdate(context, gridViewColumnId, body, req) {
        return this.gridColumnsService.gridColumnUpdate(context, {
            gridViewColumnId,
            grid: body,
            req
        });
    }
    constructor(gridColumnsService){
        this.gridColumnsService = gridColumnsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/grids/:gridViewId/grid-columns',
        '/api/v2/meta/grids/:gridViewId/grid-columns'
    ]),
    (0, _extractidsmiddleware.Acl)('columnList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('gridViewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], GridColumnsController.prototype, "columnList", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/grid-columns/:gridViewColumnId',
        '/api/v2/meta/grid-columns/:gridViewColumnId'
    ]),
    (0, _extractidsmiddleware.Acl)('gridColumnUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('gridViewColumnId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.GridColumnReqType === "undefined" ? Object : _nocodbsdk.GridColumnReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], GridColumnsController.prototype, "gridColumnUpdate", null);
GridColumnsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _gridcolumnsservice.GridColumnsService === "undefined" ? Object : _gridcolumnsservice.GridColumnsService
    ])
], GridColumnsController);
